import {IsoDate, IsoDateTime} from "../../pseudo-types/DateTypes";
import {StripeProductName} from "./StripeProductNames";
import {StripeCouponNames} from "./StripeCouponNames";

export interface SubscriptionResponse {
    subscriptions: Array<StripeUserSubscriptionRecord>;
}

export enum StripeSubscriptionStatus {
    ACTIVE = "ACTIVE",
    CANCELED = "CANCELED",
    TRIALING = "TRIALING",
    PAST_DUE = "PAST_DUE",
}

export interface StripeSubscriptionProduct {
    readonly productName: StripeProductName;
    readonly planId: string;
    readonly productDescription: string;
}

export interface StripeSubscriptionCoupon {
    readonly id: string;
    readonly name: StripeCouponNames;
}

export interface StripeUserSubscriptionRecord {
    readonly id: string;
    readonly stripeId: string;
    readonly status: StripeSubscriptionStatus;
    readonly created: IsoDate;
    readonly started: IsoDate;
    readonly trialStarted: IsoDateTime;
    readonly trialEnds: IsoDateTime;
    readonly endedAt: IsoDate;
    readonly cancelledAt: IsoDate;
    readonly products: Array<StripeSubscriptionProduct>;
}
